var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.25,
    height: 50.6,
    viewBox: "0 0 63.25 50.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-school",
    "data-name": "Icon awesome-school",
    d: "M0,22.138V49.019A1.581,1.581,0,0,0,1.581,50.6H9.488V18.975H3.163A3.163,3.163,0,0,0,0,22.138Zm35.578-4.744H33.206V13.441a.79.79,0,0,0-.791-.791H30.834a.79.79,0,0,0-.791.791v6.325a.79.79,0,0,0,.791.791h4.744a.79.79,0,0,0,.791-.791V18.184A.79.79,0,0,0,35.578,17.394Zm13.614-6.321L33.379.531a3.164,3.164,0,0,0-3.508,0L14.058,11.073A3.163,3.163,0,0,0,12.65,13.7V50.6H25.3V36.369a1.581,1.581,0,0,1,1.581-1.581h9.488a1.581,1.581,0,0,1,1.581,1.581V50.6H50.6V13.7a3.163,3.163,0,0,0-1.408-2.632ZM31.625,25.3a7.906,7.906,0,1,1,7.906-7.906A7.907,7.907,0,0,1,31.625,25.3Zm28.462-6.325H53.763V50.6h7.906a1.581,1.581,0,0,0,1.581-1.581V22.138A3.163,3.163,0,0,0,60.088,18.975Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool);
export default __webpack_public_path__ + "static/media/School.faf1a65040256b31ece918b622010022.svg";
export { ForwardRef as ReactComponent };